var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.07 6C12 6.77 12 7.74 12 8.96v14.08c0 1.22 0 2.19.07 2.96h-1.4c-3.15 0-4.72 0-5.7-.98C4 24.05 4 22.48 4 19.33v-6.66c0-3.15 0-4.72.98-5.7C5.95 6 7.52 6 10.67 6h1.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.94 3.21C12 4.05 12 5.58 12 8.63v14.74c0 3.05 0 4.58.94 5.42.95.83 2.39.58 5.27.08l3.1-.54c3.2-.56 4.8-.84 5.74-2 .95-1.18.95-2.87.95-6.26v-8.14c0-3.39 0-5.08-.95-6.25s-2.54-1.45-5.74-2l-3.1-.55c-2.88-.5-4.32-.75-5.27.08ZM17 14.61c0-.58-.45-1.05-1-1.05s-1 .47-1 1.04v2.8c0 .57.45 1.04 1 1.04s1-.47 1-1.04v-2.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashExit);
export default __webpack_public_path__ + "static/media/dash_exit.e716abdf0d77b5f55fce0d229d314793.svg";
export { ForwardRef as ReactComponent };